import React, { Fragment, useState, useEffect } from 'react';
import { Button, Form, Alert, FloatingLabel, Col, Row } from 'react-bootstrap';
import { Link, useParams } from 'react-router-dom';
import ContratoService from '../../../../../services/contrato-auth';
import Moment from 'moment';



const Contrato = () => {
    let { id } = useParams();
    const [numero, setNumero] = useState("");
    const [inicioVigencia, setInicioVigencia] = useState("");
    const [finalVigencia, setFinalVigencia] = useState("");
    const [dataAssinatura, setDataAssinatura] = useState("");
    const [situacao, setSituacao] = useState("");
    const [dataPub, setDataPub] = useState("");
    const [contratado, setContratado] = useState("");
    const [cnpj, setCnpj] = useState("");
    const [sucesso, setSucesso] = useState(false);
    const [error, setError] = useState([])


    async function fetchContrato(id) {
        const response = await ContratoService.contratoEdit(id);
        Moment.locale();
        setNumero(response.data["numero"]);
        setContratado(response.data["contratado"])
        setDataAssinatura(Moment(response.data["dataAssinatura"]).utc(false).format("yyyy-MM-DD"));
        setDataPub(Moment(response.data["dataPub"]).utc(false).format("yyyy-MM-DD"));
        setInicioVigencia(Moment(response.data["inicioVigencia"]).utc(false).format("yyyy-MM-DD"));
        setFinalVigencia(Moment(response.data["finalVigencia"]).utc(false).format("yyyy-MM-DD"));
        setSituacao(response.data["situacao"]);
        setCnpj(response.data["cnpj"]);
    }

    useEffect(() => {
        fetchContrato(id)
    }, [id])



    const HandleSubmit = async (evt) => {
        evt.preventDefault()
        try {
            const contrato = await ContratoService.editar(id, {
                numero: numero,
                inicioVigencia: inicioVigencia,
                finalVigencia: finalVigencia,
                situacao: situacao,
                dataAssinatura: dataAssinatura,
                dataPub: dataPub,
                contratado: contratado,
                cnpj: cnpj
            })
            if (contrato.data["cod_contrato"]) {
                setSucesso(true)
                setError(false)
            } else {
                setError("Deu algo errado no cadastro!")
            }
        } catch (error) {
            setError(error)
        }
    }

    if (!sucesso) {
        return (
            <Fragment>
                <Form onSubmit={HandleSubmit} encType="multipart/form-data">
                    <Row xs={1} lg={4}>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="numero">
                                <FloatingLabel
                                    label="Número do Contrato"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="number"
                                        name="numero"
                                        value={numero}
                                        onChange={e => setNumero(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="incicioVigencia">
                                <FloatingLabel
                                    label="Início da Vigência"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="date"
                                        name="inicioVigencia"
                                        value={inicioVigencia}
                                        onChange={e => setInicioVigencia(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="finalVigencia">
                                <FloatingLabel
                                    label="Final da Vigência"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="finalVigencia"
                                        value={finalVigencia}
                                        onChange={e => setFinalVigencia(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="Situação">
                                <FloatingLabel
                                    label="Situação"
                                    className="mb-3"
                                >
                                    <Form.Select
                                        required
                                        aria-label="Situação"
                                        name="situacao"
                                        onChange={e => setSituacao(e.target.value)}
                                    >
                                        <option value={situacao}>{situacao}</option>
                                        <option value="Ativo">Ativo</option>
                                        <option value="Concluído">Concluído</option>
                                        <option value="Cancelado">Cancelado</option>
                                        <option value="Rescindido">Rescindido</option>
                                    </Form.Select>
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="dataAssinatura">
                                <FloatingLabel
                                    label="Data da Assinatura"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="dataAssinatura"
                                        value={dataAssinatura}
                                        onChange={e => setDataAssinatura(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={4}>
                            <Form.Group className="mb-3" controlId="dataPub">
                                <FloatingLabel
                                    label="Data da Publicação"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        type="date"
                                        name="dataPub"
                                        value={dataPub}
                                        onChange={e => setDataPub(e.target.value)}
                                    />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="contratado">
                                <FloatingLabel
                                    label="Razão Social do Contratado"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="contratado"
                                        value={contratado}
                                        onChange={e => setContratado(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                        <Col xs={12} lg={12}>
                            <Form.Group className="mb-3" controlId="cnpj">
                                <FloatingLabel
                                    label="CPF/CNPJ"
                                    className="mb-3"
                                >
                                    <Form.Control
                                        required
                                        type="text"
                                        name="cnpj"
                                        value={cnpj}
                                        onChange={e => setCnpj(e.target.value)} />
                                </FloatingLabel>
                            </Form.Group>
                        </Col>
                    </Row>
                    {error.length >= 1 ? <Alert variant="danger"> {[...error]}</Alert> : ''}
                    <Button variant="primary" type="submit">
                        Salvar
                    </Button>
                </Form >
                <br />
                <Link to={'/restrito/contratos/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment >
        )
    } else {
        return (
            <Fragment>
                <Alert variant='success'>Contrato atualizado com sucesso!</Alert>
                <Link to={'/restrito/contratos/listar'}>
                    <Button variant="primary" type="button">
                        Ir para Listagem de Contratos
                    </Button>
                </Link>
                <br /><br />
                <Link to={'/restrito/contratos/listar'}>
                    <Button variant="danger" type="button">
                        Voltar
                    </Button>
                </Link>
            </Fragment>
        )
    }
}

export default Contrato;